import { render, staticRenderFns } from "./groupData.vue?vue&type=template&id=368349d9&scoped=true"
import script from "./groupData.vue?vue&type=script&lang=js"
export * from "./groupData.vue?vue&type=script&lang=js"
import style0 from "./groupData.vue?vue&type=style&index=0&id=368349d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368349d9",
  null
  
)

export default component.exports